var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueRoundL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 46,
    viewBox: "0 0 1440 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_802_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 46
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 46,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_802_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440.69,
    height: 877.846,
    rx: 95,
    transform: "matrix(0.997712 0.0676152 -0.0535246 0.998567 24.7974 -2)",
    fill: "#0C4B76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRoundL);
export default __webpack_public_path__ + "static/media/blue-round-l.0ba25d6f994204cc52c9a35730a62391.svg";
export { ForwardRef as ReactComponent };